const useFieldHasError = <T extends Record<string,any> >(
    form: T
  ) => {
    return (key: keyof T,) => {
      const field = form[key];
      const submitAttempt=form['submitAttempt']
      return !field?.isValid  && submitAttempt;
    };
  };
  
  export { useFieldHasError };